import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle2, Info } from 'lucide-react';

export const DetailCard = ({ title, items }: { title: string; items: string[] }) => (
  <Card className="border-border">
    <CardHeader><CardTitle className="text-base">{title}</CardTitle></CardHeader>
    <CardContent>
      <ul className="space-y-2 text-sm text-muted-foreground">
        {items.map((item, i) => (
          <li key={i} className="flex items-start gap-2">
            <Info className="w-3.5 h-3.5 mt-0.5 shrink-0 text-primary" />
            {item}
          </li>
        ))}
      </ul>
    </CardContent>
  </Card>
);

export const BulletCard = ({ title, items, colorClass }: { title: string; items: string[]; colorClass: string }) => (
  <Card className="border-border">
    <CardHeader><CardTitle className={`text-sm ${colorClass}`}>{title}</CardTitle></CardHeader>
    <CardContent>
      <ul className="space-y-2 text-sm text-muted-foreground">
        {items.map((item, i) => (
          <li key={i} className="flex items-start gap-2">
            <CheckCircle2 className={`w-3.5 h-3.5 mt-0.5 shrink-0 ${colorClass}`} />
            {item}
          </li>
        ))}
      </ul>
    </CardContent>
  </Card>
);
